export default {
    removeSocialMedia: {
        text: 'The social network {{0}} has been deleted',
    },
    addSocialMedia: {
        text: 'The social network {{0}} has been added',
    },
    instaConnect: 'The social network Instagram has been added',
};
